import produce from "immer"
import { ASC } from "const"
import { MarkovGroup } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovGroup: MarkovGroup = {
    id: null,
    modelId: null,
    name: "",
    description: "",
    order: 0,
}

const initMarkovGroupState: types.MarkovGroupState = {
    groupList: {},
    groupIds: [],
    groupEdit: initMarkovGroup,

    sortColumn: "order",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const markovGroupReducer = produce((
    draft: types.MarkovGroupState = initMarkovGroupState,
    action: ActionTypes = null,
): types.MarkovGroupState => {
    switch (action.type) {
        case types.MARKOV_GROUP_LIST:
            draft.groupList = action.groupList
            return draft

        case types.MARKOV_GROUP_IDS:
            draft.groupIds = action.groupIds
            return draft

        case types.MARKOV_GROUP_EDIT:
            draft.groupEdit = action.group
            return draft

        case types.MARKOV_GROUP_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.MARKOV_GROUP_FILTERS:
            draft.filters = action.filters
            return draft

        case types.MARKOV_GROUP_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_GROUP_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovGroupReducer
